// extracted by mini-css-extract-plugin
export default {"wrapper":"ManagementPage_wrapper__sVZHy","managers_list":"ManagementPage_managers_list__J7+oV"};